var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "user-center-slot",
    [
      _c(
        "user-center-container-slot",
        [
          _c("user-center-menu"),
          _vm._v(" "),
          _c(
            "user-center-content-slot",
            [
              _c("user-center-content-title", { attrs: { title: "消息中心" } }),
              _vm._v(" "),
              _c("div", { staticClass: "user-center__msg-row" }, [
                _c("div", [
                  _c("i", {
                    staticClass:
                      "iconfont icon-xiaoxi user-center__msg-icon--default"
                  })
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "user-center__msg-number" }, [
                  _vm._v(" 您有"),
                  _c("span", {
                    staticClass: "user-center__msg-number-txt",
                    attrs: { id: "msgNum" }
                  }),
                  _vm._v("条新消息")
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "user-center__msg-operation" }, [
                _c(
                  "a",
                  {
                    staticClass: "user-center__msg-operation-button",
                    attrs: { href: "javascript:void(0);" },
                    on: { click: _vm.updateMsgCenterState }
                  },
                  [_vm._v("全部标记已读")]
                ),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    staticClass: "user-center__msg-operation-button",
                    attrs: { href: "javascript:void(0);" },
                    on: { click: _vm.delHandle }
                  },
                  [_vm._v("删除选中消息")]
                )
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "user-center__msg-list" },
                [
                  _c(
                    "xui-table",
                    {
                      staticStyle: { width: "100%" },
                      attrs: {
                        data: _vm.latestData,
                        stripe: false,
                        "show-header": true
                      },
                      on: { "selection-change": _vm.handleSelectionChange }
                    },
                    [
                      _c("xui-table-column", {
                        attrs: {
                          type: "selection",
                          align: "center",
                          width: "33"
                        }
                      }),
                      _vm._v(" "),
                      _c("xui-table-column", {
                        attrs: {
                          "min-width": "96",
                          prop: "title",
                          label: "消息主题",
                          "show-overflow-tooltip": "",
                          align: "left"
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                _c(
                                  "a",
                                  {
                                    staticClass: "user-center__msg-list-link",
                                    attrs: { href: "javascript:void(0);" },
                                    on: {
                                      click: function($event) {
                                        return _vm.showDetail(scope.row)
                                      }
                                    }
                                  },
                                  [_vm._v(_vm._s(scope.row.title))]
                                )
                              ]
                            }
                          }
                        ])
                      }),
                      _vm._v(" "),
                      _c("xui-table-column", {
                        staticClass: "is-top",
                        attrs: { prop: "status", label: "消息类型" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(
                                      scope.row.status
                                        ? _vm.statusOption[scope.row.status]
                                            .label
                                        : _vm.statusOption[scope.row.status]
                                            .label
                                    ) +
                                    "\n              "
                                )
                              ]
                            }
                          }
                        ])
                      }),
                      _vm._v(" "),
                      _c("xui-table-column", {
                        staticClass: "is-top",
                        attrs: { prop: "creationDate", label: "发送时间" }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "user-center__msg-pager" },
                [
                  _c("xui-pagination", {
                    attrs: {
                      "current-page": _vm.currentPage,
                      "page-size": 5,
                      layout: "total, pager, jumper",
                      total: _vm.total
                    },
                    on: {
                      "current-change": _vm.handleCurrentChange,
                      "update:currentPage": function($event) {
                        _vm.currentPage = $event
                      },
                      "update:current-page": function($event) {
                        _vm.currentPage = $event
                      }
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "xui-dialog",
        {
          attrs: {
            title: "",
            "close-on-click-modal": false,
            showcenter: "",
            visible: _vm.delWarnning,
            width: "30%"
          },
          on: {
            "update:visible": function($event) {
              _vm.delWarnning = $event
            }
          }
        },
        [
          _c("p", { staticClass: "dialog-content" }, [
            _c("span", [
              _c("img", {
                staticClass: "img-status",
                attrs: { src: require("../../../images/message.png") }
              })
            ])
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "dialog-content" }, [
            _c("span", [_vm._v(" 请选择需要删除的消息！ ")])
          ])
        ]
      ),
      _vm._v(" "),
      _vm.isNotLogin && _vm.isEffect
        ? _c(
            "xui-dialog",
            {
              staticClass: "login-dialog",
              attrs: {
                title: "失效提醒",
                "close-on-click-modal": false,
                showcenter: "",
                visible: _vm.isNotLogin,
                width: "30%"
              },
              on: {
                "update:visible": function($event) {
                  _vm.isNotLogin = $event
                },
                close: _vm.handleClose
              }
            },
            [
              _c("span", [_vm._v("您的账号已经失效，请联系管理员")]),
              _vm._v(" "),
              _c(
                "span",
                {
                  staticClass: "dialog-footer",
                  attrs: { slot: "footer", center: "" },
                  slot: "footer"
                },
                [
                  _c(
                    "xui-button",
                    {
                      attrs: { type: "primary", size: "bigger" },
                      on: { click: _vm.handleClose }
                    },
                    [_vm._v("返回首页")]
                  )
                ],
                1
              )
            ]
          )
        : _c(
            "xui-dialog",
            {
              staticClass: "login-dialog",
              attrs: {
                title: "登录提醒",
                "close-on-click-modal": false,
                showcenter: "",
                visible: _vm.isNotLogin,
                width: "30%"
              },
              on: {
                "update:visible": function($event) {
                  _vm.isNotLogin = $event
                },
                close: _vm.handleClose
              }
            },
            [
              _c("span", [_vm._v("系统检测到您未登录或登录失效，请先登录")]),
              _vm._v(" "),
              _c(
                "span",
                {
                  staticClass: "dialog-footer",
                  attrs: { slot: "footer", center: "" },
                  slot: "footer"
                },
                [
                  _c(
                    "xui-button",
                    {
                      attrs: { type: "primary", size: "bigger" },
                      on: { click: _vm.login }
                    },
                    [_vm._v("荣耀账号登录")]
                  )
                ],
                1
              )
            ]
          ),
      _vm._v(" "),
      _c(
        "xui-dialog",
        {
          attrs: {
            "close-on-click-modal": false,
            showcenter: "",
            visible: _vm.dialogVisible,
            width: "600px"
          },
          on: {
            "update:visible": function($event) {
              _vm.dialogVisible = $event
            },
            close: _vm.handleCloseByMsg
          }
        },
        [
          _c("div", { staticClass: "msg-title" }, [
            _vm._v("\n      " + _vm._s(_vm.msgData.title) + "\n    ")
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "msg-html" }, [
            _c("div", { staticClass: "addresseeName" }, [
              _vm._v(_vm._s(_vm.msgData.userName))
            ]),
            _vm._v(" "),
            _c("div", { domProps: { innerHTML: _vm._s(_vm.msgData.concent) } })
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "msg-time" }, [
            _vm._v("\n      " + _vm._s(_vm.msgData.creationDate) + "\n    ")
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-84676d60", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-84676d60","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/usercenter/sitemsg/UsercenterSiteMsg.vue
// module id = null
// module chunks = 